export default __webpack_public_path__ + "static/media/colony.e4691775.jpg";